import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Description = /*#__PURE__*/memo(function (_ref) {
  var description = _ref.description,
    showCompactParameters = _ref.showCompactParameters;
  var descriptions = typeof description === 'string' ? [{
    text: description
  }] : description;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React.createElement("div", {
      className: cn('descriptions', {
        'descriptions--top': showCompactParameters
      }),
      "data-t-id": "components-Description"
    }, !!(descriptions !== null && descriptions !== void 0 && descriptions.length) && descriptions.map(function (item) {
      return /*#__PURE__*/React.createElement("div", {
        className: cn('description')
      }, item.icon && /*#__PURE__*/React.createElement("div", {
        className: cn('icon')
      }, /*#__PURE__*/React.createElement("img", {
        alt: "",
        className: cn('icon__img'),
        src: item.icon
      })), /*#__PURE__*/React.createElement(Text, {
        color: "grey60",
        size: "size5-r-l"
      }, item.text));
    }))
  );
});